<template>
  <button class="app-button btn" @click="handleClick" :disabled="disabled">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'AppButton',

  props: {
    disabled: {
      default: false
    }
  },

  methods: {
    handleClick(e) {
      this.$emit('click', e)
    }
  }
}
</script>

<style scoped>
.app-button.default {
  background: #33537e;
  color: #fff;
}
.app-button:hover {
  opacity: 0.9;
}
.app-button:disabled {
  opacity: 0.8;
}
</style>
